import { SAVE_URL_QUERY } from '../constants/actionTypes';

export function saveUrlQuery(query = {}) {
  // eslint-disable-line import/prefer-default-export
  return {
    type: SAVE_URL_QUERY,
    query
  };
}
